/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function () {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );

  if ('serviceWorker' in navigator &&
    (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
      .then(function (registration) {
        // updatefound is fired if service-worker.js changes.
        registration.onupdatefound = function () {
          // updatefound is also fired the very first time the SW is installed,
          // and there's no need to prompt for a reload at that point.
          // So check here to see if the page is already controlled,
          // i.e. whether there's an existing service worker.
          if (navigator.serviceWorker.controller) {
            // The updatefound event implies that registration.installing is set:
            // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
            var installingWorker = registration.installing;

            installingWorker.onstatechange = function () {
              switch (installingWorker.state) {
                case 'installed':
                  // At this point, the old content will have been purged and the
                  // fresh content will have been added to the cache.
                  // It's the perfect time to display a "New content is
                  // available; please refresh." message in the page's interface.
                  break;

                case 'redundant':
                  throw new Error('The installing ' +
                    'service worker became redundant.');

                default:
                // Ignore
              }
            };
          }
        };
      }).catch(function (e) {
        console.error('Error during service worker registration:', e);
      });
  }

  // Your custom JavaScript goes here
  $(window).on('beforeunload', function () {
    $('.loader-wrap').removeClass('hide');
    $(window).scrollTop(0);
    $('#logo').removeClass('fadeNow');
  });


  $(document).on('submit', '#form-inquiry', function (e) {
    e.preventDefault();

    var element = $(this);
    $.ajax({
      url: 'api/index.php',
      type: element.attr('method'),
      data: element.serialize(),
      dataType: 'JSON',
      beforeSend: function () {

      },
      success: function (data) {
        console.log(data);
        if (data.status) {
          element[0].reset();
          $('.popup-success').addClass('show');
          setTimeout(function () { $('.popup-success').removeClass('show'); }, 3001);
        }
        else {

        }
      },
      error: function (jqXHR, textStatus, errorThrown) {

      }
    });

  });



  $(document).ready(function(){
    var unlikeVideo = videojs('videoUnlike', { fluid: true});
    var igaVideo = videojs('igavideo', { fluid: true, poster: './assets/images/animated-poster.jpg'});
    var retakeVideo = videojs('retakeVideo', { fluid: true, poster: './assets/images/img_video1.png' });
    var retakeVideo2 = videojs('retakeVideo2', { fluid: true, poster: './assets/images/img_video1.png'});
    var passionVideo = videojs('passionVideo', { fluid: true, poster: './assets/images/passion-poster.png'});
    var logoPos = 0;

    // if( $(window).innerHeight() >=1080 ) {
    //   var logoPercent = "35%";
    //}
    // if($(window).innerHeight() >= 600 && $(window).innerHeight() < 650){
    //   logoPercent = "95%";
    // }
    // else if($(window).innerHeight() >= 650 && $(window).innerHeight() < 700){
    //   logoPercent = "85%";
    // }
    // else if($(window).innerHeight() >= 700 && $(window).innerHeight() < 750){
    //   logoPercent = "75%";
    // }
    // else if($(window).innerHeight() >= 750 && $(window).innerHeight() < 800){
    //   logoPercent = "67%";
    // }
    // else if($(window).innerHeight() >= 800 && $(window).innerHeight() < 950){
    //   logoPercent = "55%";
    // }
    // else if($(window).innerHeight() >= 950 && $(window).innerHeight() < 1000){
    //   logoPercent = "45%";
    // }
    // else if($(window).innerHeight() >= 1000 && $(window).innerHeight() < 1450){
    //   logoPercent = "40%";
    // }
    // else if($(window).innerHeight() >= 1450 && $(window).innerHeight() < 1850){
    //   logoPercent = "42%";
    // }
    var unlike = false, iga = false, retake = false, passion = false, pitcher = false, retake2 = false;

    var IntroMainScene = new TimelineMax();

    var painting = function(el){
      var count = $(el + ' path').length;

      if($(el).hasClass('complete')){
        $(el + ' path').each(function(i){
          this.style.strokeOpacity = 0;
          if (!--count){
            $(el).removeClass('complete');
            $(el).lazylinepainter('paint');
          }
        });
      }else{
        $(el).lazylinepainter('paint');
      }
    };

    IntroMainScene
      .set('#spl-yl', { scale: 0 }, 0)
      .set('#spl', { scale: 0 }, 0);
      //.to('#videoText', 0.1, { autoAlpha: 1, ease: Power4.easeOut, onStart: playUnlikeVideo }, 0);

      // Preloader
      setTimeout(function () {
        $('.loader-wrap').addClass('hide');
      }, 1500);
      setTimeout(function () {
        $('#logo').addClass('fadeNow');
      }, 2000);
      setTimeout(function () {
        $('#logo').addClass('blurtoclear');
        //$('#logo').delay(5000).addClass('changetrans');
      }, 2500);

      /*
      setTimeout(function(){
       logoPos = $('.content').height() - $('.logo-wrapper').offset().top - $('.logo-wrapper').height() - $('#unlikeDesc').height() - 10;
       animText2
        .to('#unlikeDesc', 8, { autoAlpha: 1, ease: Power0.easeNone }, '+=1')
        //.to('#logo .logo-wrapper', 2, {y: $(window).innerWidth() > 768 ? logoPos : 0, ease:Power3.easeIn}, 0);
       textScene2.setTween(animText2);

      }, 5000);
      */

      function playUnlikeVideo() {
        unlikeVideo.ready(function() {
          unlikeVideo.playbackRate(1.5);
          unlikeVideo.play();
          unlike = true;
        });
      }

      setTimeout(function () {
        $('.fadeLoad').addClass('in');

          // .to('#unlikeDesc', 3, { autoAlpha: 1, ease: Power0.easeNone }, '+=1');
      }, 8000);

      // animText2
      // .to('#unlikeDesc', 8, { autoAlpha: 1, ease: Power0.easeNone }, '+=1')
      // textScene2.setTween(animText2);


      IntroMainScene
      .to('#videoText', 0.1, { autoAlpha: 1, ease: Power4.easeOut, onStart: playUnlikeVideo }, 4)
      .fromTo('#spl-yl', 0.6, { scale: 0.75, ease: Power1.easeOut }, { scale: 1, autoAlpha: 1, ease: Power1.easeOut }, 3.5)
      .fromTo('#spl', 0.6, { scale: 0.75, ease: Power1.easeOut }, { scale: 1, autoAlpha: 1, ease: Power1.easeOut }, 3.5)
      .staggerTo($('.org-fade'), 0.5, { autoAlpha: 1, ease: Power1.easeOut }, 0.2, "introFade")
      .staggerTo($('.stw-fade'), 0.5, { autoAlpha: 1, ease: Power1.easeOut }, 0.2, "introFade");

      // setTimeout(function (){
      //   $('#logo').addClass('changetrans');

      // }, 5500);

      // setTimeout(function(){
      //   $('#unlikeanyotherpath').lazylinepainter('paint');
      // }, 7000);

      // Init ScrollMagic
      var controller = new ScrollMagic.Controller();

      // pin the intro
      var pinIntroScene = new ScrollMagic.Scene({
          triggerElement: '#intro',
          triggerHook: 0,
          duration: '100%'
        })
        .setPin('#intro')
        .addTo(controller);

        //animation onleave
      var leaveIntro = new TimelineMax();
      leaveIntro
        .to('#org-slice',1,{y:135, rotation:85, x:-50, ease:Power4.easeOut},0)
        .to('#org-1',1,{y:30, x:-80, ease:Power4.easeOut},0)
        .to('#org-2',1,{rotation:45, x:-80, ease:Power4.easeOut},0)
        .to('#org-3',1,{y:50, x:-80, ease:Power4.easeOut},0)
        .to('#org-4',1,{y:150, x:-100, ease:Power4.easeOut},0)
        .to('#stw-slice',1,{y:75, rotation:-85, x:50, ease:Power4.easeOut},0)
        .to('#stw1', 0.3, {y: 50, x: 50, ease:Power0.easeNone}, 0)
        .to('#stw3', 0.3, {x: 50, ease:Power0.easeNone}, 0);

        // leave intro
      var leaveIntroScene = new ScrollMagic.Scene({
          triggerElement: '#intro',
          triggerHook: 0,
          duration: '60%'
        })
        .setTween(leaveIntro)
        .addTo(controller);

      //animation onleave
      var leaveIntro2 = new TimelineMax();
      leaveIntro2
        .to('#stw2', 0.3, {y: 50, x:100, rotation:-55, ease:Power0.easeNone}, 0)

      // pin the intro
      var leaveIntroScene2 = new ScrollMagic.Scene({
          triggerElement: '#intro',
          triggerHook: 0,
          duration: '20%'
        })
        .setTween(leaveIntro2)
        .addTo(controller);


      //animation Unlike Other onleave
      var animText = new TimelineMax();
      animText
        //.to('#logo logo-wrapper', 10, {scale:$(window).innerWidth()>768?1.15:0.85, y:$(window).innerWidth()>768?30:0, ease:Power0.easeNone}, 0)
        .to('#videoText', 4, {autoAlpha:$(window).innerWidth()>768?0:1, ease:Power3.easeOut}, 5);

        // .to('#intro h1', 1, {y: 50, x:50, skewX:'20deg', transformPerspective: 20,rotation:'10deg', ease:Power0.easeNone}, 0)
        // .to('#videoText', 1, {autoAlpha:1, ease:Power0.easeNone, onStart:playUnlikeVideo}, '+=0.2')

      var textScene = new ScrollMagic.Scene({
          triggerElement: '#intro',
          duration: '100%',
          triggerHook: 0
      })
      .setTween(animText)
      .addTo(controller);

      // function getPitcherFaster(){
      //   var videoHeight = $('#videoText').height();
      //   $('#main').css('margin-top', '-'+ (videoHeight-15) +'px');
      // }


      // function limitLogo(){

      //   else{
      //     var yPercent = 130+"%";
      //   }
      // }

      var animText2 = new TimelineMax();
      animText2
        .to('#unlikeDesc', 8, { autoAlpha: 1, ease: Power0.easeNone }, '+=1')
        //.to('#logo .logo-wrapper', 2, {y:$(window).innerWidth() > 768 ? logoPos : 0, ease:Power3.easeIn}, 0);


      var textScene2 = new ScrollMagic.Scene({
          triggerElement: '#main',
          duration: 200,
          triggerHook: 1
        })
        .setTween(animText2)
        .addTo(controller);

      //SECTION 1/////////////////////////
      var section01 = new TimelineMax();
      section01
        .fromTo('#cerri1', 500, {x: -180, autoAlpha:0, delay:0.5, rotation:30, ease:Power0.easeNone}, {x: 0, autoAlpha:1, rotation:0, ease:Power0.easeNone}, '+=0.4')
        .fromTo('#cerri2', 500, {x: -180, autoAlpha:0, delay:1, rotation:-30, ease:Power0.easeNone}, {x: 0, autoAlpha:1, rotation:0, ease:Power0.easeNone}, '+=0.8')
        .fromTo('#cerri3', 500, {x: -180, autoAlpha:0, delay:1.5, rotation:30, ease:Power0.easeNone}, {x: 0, autoAlpha:1, rotation:0, ease:Power0.easeNone}, '+=1.4')
        .fromTo('#mintsplash', 200, {x: 150, scale: 0.75, autoAlpha:0, rotation:15, delay:0.2, ease:Power0.easeNone}, {x: 0, scale: 1, autoAlpha:1, rotation:0, delay:0.2, ease:Power0.easeNone}, 0)
        .fromTo('#mint1', 500, {x: 100, autoAlpha:0, delay:0.5, ease:Power0.easeNone}, {x: 0, autoAlpha:1, rotation:-15, ease:Power0.easeNone},'+=0.4')
        .fromTo('#mint2', 550, {x: 100, autoAlpha:0, delay:1, ease:Power0.easeNone}, {x: 0, autoAlpha:1, rotation:15, ease:Power0.easeNone},'+=0.8')
        .fromTo('#mint3', 500, {x: 100, autoAlpha:0, delay:1.5, ease:Power0.easeNone}, {x: 0, autoAlpha:1, rotation:-15, ease:Power0.easeNone},'+=1.4')
        .fromTo('#cerri1', 850, {x: 0, y:0, delay:1.2, ease:Power0.easeNone}, {x: 0, y:60, ease:Power0.easeNone}, '+=0.4')
        .fromTo('#cerri2', 850, {x: 0, y:0, delay:1.2, ease:Power0.easeNone}, {x: 0, y:30, rotation: -20, ease:Power0.easeNone}, '+=0.8')
        .fromTo('#cerri3', 850, {x: 0, y:0, delay:1.2, ease:Power0.easeNone}, {x: 0, y:40, rotation: 15, ease:Power0.easeNone}, '+=1.4')
        .fromTo('#section01 .info', 5500, {y: 50, autoAlpha:0, ease:Power1.easeIn}, {y: 0, autoAlpha:1, ease:Power0.easeIn}, 0)
        // .fromTo('#mintsplash', 550, {x: 0, y:0, delay:1.2, ease:Power0.easeNone}, {x: 0, y:0, ease:Power0.easeNone}, '-=2')
        .fromTo('#mint1', 250, {x: 0, y:0, delay:0, ease:Power0.easeNone}, {x: 0, y:20, rotation:-10, ease:Power0.easeNone}, '-=10')
        .fromTo('#mint2', 250, {x: 0, y:0, delay:0, ease:Power0.easeNone}, {x: 0, y:10, rotation: 10, ease:Power0.easeNone}, '-=0.8')
        .fromTo('#mint3', 250, {x: 0, y:0, delay:0, ease:Power0.easeNone}, {x: 0, y:55, rotation: 10, ease:Power0.easeNone}, '-=0.8');

      var section01_leave = new TimelineMax();
      section01_leave
        .fromTo('#cerri1', 850, {x: 0, y:60, ease:Power0.easeNone}, {x: -50, autoAlpha:1, delay:0.5, rotation:30, ease:Power0.easeNone}, '+=8')
        .fromTo('#cerri2', 850, {x: 0, y:30, rotation: -20, ease:Power0.easeNone}, {x: -50, autoAlpha:1, delay:1, rotation:-30, ease:Power0.easeNone}, '+=0.1')
        .fromTo('#cerri3', 850, {x: 0, y:40, rotation: 15, ease:Power0.easeNone}, {x: -50, autoAlpha:1, delay:1.5, rotation:30, ease:Power0.easeNone}, '+=0.1')
        .fromTo('#mint1', 250, {x: 0, y:20, rotation:-10, ease:Power0.easeNone}, {x: 150, y:0, delay:0, ease:Power0.easeNone}, '-=10')
        .fromTo('#mint2', 250, {x: 0, y:10, rotation: 10, ease:Power0.easeNone}, {x: 150, y:0, delay:0, ease:Power0.easeNone}, '-=0.8')
        .fromTo('#mint3', 250, {x: 0, y:55, rotation: 10, ease:Power0.easeNone}, {x: 150, y:0, delay:0, ease:Power0.easeNone}, '-=0.8')
        .fromTo('#mintsplash', 250, {x: 0, y:0, delay:0, ease:Power0.easeNone}, {x: 50, y:0, scale: 0.75, rotation:15, ease:Power0.easeNone}, '-=10');

        // pin the intro
      var section01Scene = new ScrollMagic.Scene({
          triggerElement: '#section01',
          triggerHook: 0.9,
          duration: 500
        })
        .setTween(section01)
        .addTo(controller);

      var section01Scene_leave = new ScrollMagic.Scene({
          triggerElement: '#section01',
          triggerHook: 0.2,
          duration: '50%'
        })
        .setTween(section01_leave)
        .addTo(controller);

      function playRetakeVideo(){
        retakeVideo.play();
        retake = true;
      }

      var section02Duration = $(window).width() <= 1600 ? 500 : '20%';
      //SECTION 2///////////////////////
      var section02 = new TimelineMax();
      section02
          // .set('#section02 .info p', {autoAlpha: 0},0)
        .from('#section02 #ourNaturalpro', 1, {autoAlpha:0, ease:Power0.easeNone, onComplete: function(){ painting('#ourNaturalpro'); }}, 0)
        .from('#section02 .info', 0.5, {x: -50, autoAlpha:0, ease:Power0.easeNone}, '+=0.3')
        .from('#section02 .stroke', 0.1, {y: -50, x: 50, scale:0.9, autoAlpha:0, ease:Power0.easeNone},'+=0.3')
        .from('#splash', 0.5, {x: -150, autoAlpha:0,  ease:Power0.easeNone},'+=0.8')
        .from('#section02 .oranges',2, {y: -50, autoAlpha:0, ease:Power3.easeOut},'-=0.3')
        .from('#section02 .info p', 0.5, {autoAlpha: 0, ease:Power0.easeNone}, '-=1.5')
        .from('#section02 #video1', 2, {y: 50, autoAlpha:0, ease:Power4.easeOut, onStart: playRetakeVideo}, '-=1.8')
        .to('#section01',1, {autoAlpha:0, ease:Power4.easeOut},'-=2');

      var section02Scene = new ScrollMagic.Scene({
          triggerElement: '#section02',
          triggerHook:0.7,
          duration: '50%'
        })
        .setTween(section02)
        .addTo(controller);

      var orangesThemes = new TimelineMax();
      orangesThemes
        .to('#oranges1', 1.5, {rotation:-45, y:100, ease:Power4.easeNone}, 0.5)
        .to('#oranges', 1.5,  {rotation:90, y:50, ease:Power4.easeOut}, 0.5)
        .to('#oranges3', 1.5, {rotation:90, y:100, ease:Power4.easeOut}, 0.5)
        .to('#oranges4', 1.5, {rotation:90, y: 200, ease:Power4.easeOut}, 0.5);

      var orangesScene = new ScrollMagic.Scene({
          triggerElement: '#section02',
          triggerHook: 0.8,
          duration:2000
        })
        .setTween(orangesThemes)
        .addTo(controller);

       //animation onleave
       var leaveSection2 = new TimelineMax();
       leaveSection2
        .to('#section02 .info', 0.5, {autoAlpha:0, ease:Power4.easeOut}, 0.2)
        .to('#section02 .stroke', 0.5, {autoAlpha:0, ease:Power4.easeOut},0.2)
        .to('#splash', 0.5, {autoAlpha:0, ease:Power2.easeOut},0.2)
        .to('#section02 #video1', 1, {autoAlpha:0, ease:Power4.easeOut}, 0)
        .to('#bggreen-top', 1, {autoAlpha:0, ease:Power4.easeOut}, 0)
        ;
        // .to('#section02', 0.5, {autoAlpha:0, ease:Power4.easeOut}, 0.2)

      // pin the intro
      var leaveSectionScene2 = new ScrollMagic.Scene({
          triggerElement: '#section03',
          //triggerHook: 0.05,
          triggerHook : 0.7,
          duration: 100
        })
        .setTween(leaveSection2)
        .addTo(controller);

      //SECTION 3///////////////////////
      var section03 = new TimelineMax();
      if($(window).width() <= 1024){
        section03
          // .to('#section02 .oranges',1, {autoAlpha:0, ease:Power4.easeOut},10)
          .from('#orangedrink', 1, {y: 150, autoAlpha:0, ease:Power0.easeNone}, 0)
          .from('#section03 .heading', 3, {y: 50, autoAlpha:0, ease:Power0.easeNone, onStart: DrawLineQualitySVG},0)
          .from('#section03 .info', 2, {y: 50, autoAlpha:0, delay: 2, ease:Power0.easeNone}, 0.2)
          .from('#section03 h3', 6, {y: 70, autoAlpha:0, delay: 7, ease:Power0.easeNone}, "+=4")
          .from('#splashgreen', 2, {y:-30, delay:0.5,autoAlpha:0, scale:0, ease:Power0.easeNone}, "+=0.2")
          .from('#iga', 1, {y: 50, autoAlpha:0, ease:Power0.easeNone, onComplete: playTheIGAVideo}, "+=0.2")
          .to('#iga .stroke', 0.5, {y: 50, x: -50, autoAlpha:1, ease:Power0.easeNone}, "+=0.2");
      }else{
        section03
          // .to('#section02 .oranges',1, {autoAlpha:0, ease:Power4.easeOut},5)
          .from('#orangedrink', 1, {y: 150, autoAlpha:0, ease:Power0.easeNone}, 1)
          .from('#section03 .heading', 3, {y: 50, autoAlpha:0, ease:Power0.easeNone, onStart: DrawLineQualitySVG},0)
          .from('#section03 .info', 2, {y: 50, autoAlpha:0, ease:Power0.easeNone}, 0.5)
          // .from('#section03 h3', 6, {y: 70, autoAlpha:0, ease:Power0.easeNone}, "+=1.2")
          // .from('#section03 .info', 2, {y: 50, autoAlpha:0, delay: 2, ease:Power0.easeNone}, 0.5)
          .from('#section03 h3', 8, {y: 70, autoAlpha:0, delay: 60, ease:Power0.easeNone}, "+=0.8")

          .from('#iga', 1, {y: 50, autoAlpha:0, ease:Power0.easeNone, onComplete: playTheIGAVideo}, "+=0.4")
          .to('#iga .stroke', 0.5, {y: 50, x: -50, autoAlpha:1, ease:Power0.easeNone}, "+=0.2")
          .from('#splashgreen', 5, {y:-50, delay:1.5,autoAlpha:0, scale:0, ease:Power0.easeNone}, "+=0.2")
          .from('.apples-parralax', 5, {delay:0.5, autoAlpha:0, ease:Power0.easeNone}, "+=0.2");
      }

        // pin the intro
      var section03Scene = new ScrollMagic.Scene({
          triggerElement: '#section03',
          triggerHook: 0.65,
          //triggerHook: 0.8,
          duration: 700
          // triggerHook: 0.5,
          // duration: 700
        })
        .setTween(section03)
        .addTo(controller)
        .on("enter", function (event) {
          $('#section03 p, #orangedrink, #text-quality-01').css('opacity', 1);
        })
        .on("leave", function (event) {
            $('#section03 p, #orangedrink, #text-quality-01').css('opacity', 0);
        });

      function DrawLineQualitySVG(){
        painting('#text-quality-01');
      }

      function playTheIGAVideo(){
        igaVideo.play();
        iga = true;
      }

      var applesThemes = new TimelineMax();
      applesThemes
        .fromTo('#img_apple1', 1, {rotation:0, autoAlpha:1, ease:Power4.easeNone}, {rotation:45, ease:Power4.easeNone}, 1)
        .fromTo('#img_apple2', 1, {y: 0, autoAlpha:1, ease:Power4.easeOut}, {y: 90, ease:Power4.easeOut}, 1)
        .fromTo('#img_apple3', 1, {rotation:0, y: 0, autoAlpha:1, ease:Power4.easeOut}, {rotation:45, y: 90, ease:Power4.easeOut}, 1)
        .fromTo('#img_apple4', 1, {y: 0, autoAlpha:1, ease:Power4.easeOut}, {y: 100, ease:Power4.easeOut}, 1)
        .fromTo('#img_apple5', 1, {y: 0, autoAlpha:1, ease:Power4.easeOut}, {y: 170, ease:Power4.easeOut}, 1)
        // .from('.apples-parralax', 5, {y:50,delay:0.5, autoAlpha:0, ease:Power0.easeNone}, "+=0.2")
        ;

      var applesScene = new ScrollMagic.Scene({
          triggerElement: '#section03',
          triggerHook: 0.7,
          duration: 2000
        })
        .setTween(applesThemes)
        .addTo(controller);

      // pin
      // var pinScene04 = new ScrollMagic.Scene({
      //   triggerElement: '#section04',
      //   triggerHook: 0,
      //       duration: '300%'
      // })
      // .setPin('#section04')
      // .addTo(controller);

      //SECTION 4///////////////////////
      var section04 = new TimelineMax();
      section04
        .from('#pitcher', 5, {y: 150, x: 200, rotation: 25, autoAlpha:0, ease:Power0.easeNone}, 0)
        .from('#water', 7, {y: 180, x: 380, rotation: 30, autoAlpha:0, ease:Power0.easeNone},0.2)
        .from('#ice1', 6, {y: 50, x: 500, rotation: 30, autoAlpha:0, ease:Power0.easeNone},0.2)
        .from('#ice2', 6, {y: 160, x: 360, rotation: 25, autoAlpha:0, ease:Power0.easeNone},0.6)
        .from('#leave', 6, {y: 10, x: 120, scale: 0.9, rotation: 20, autoAlpha:0, ease:Power0.easeNone},0.6)
        .from('#lemon', 6, {y: 10, x: 120, autoAlpha:0,  ease:Expo.easeInOut},1)
        .from('#orgice', 7, {y: 50, x: 70, autoAlpha:0,  ease:Expo.easeInOut},1)
        .from('#lemon2', 6, {y: 10, x: 120, rotation:75, autoAlpha:0,ease:Power0.easeNone},0.6)
        // .from('#section04 .info', 1, {y: 30, delay:5, autoAlpha:0, ease:Power0.easeNone},1.2)
        .to('#ice1', 46, {y: 100, rotation: 100, ease:Power0.easeNone},3)
        .to('#lemon2', 46, {y: 150, rotation: 120, ease:Power0.easeNone},3);

        /**
        .from('#pitcher', 5, {y: 150, x: 200, rotation: 25, autoAlpha:0, ease:Power0.easeNone}, 0)
        .from('#water', 4.5, {y: 180, x: 380, rotation: 30, autoAlpha:0, ease:Power0.easeNone},0.2)
        .from('#ice1', 4, {y: 50, x: 500, rotation: 30, autoAlpha:0, ease:Power0.easeNone},0.2)
        .from('#ice2', 4, {y: 160, x: 360, rotation: 25, autoAlpha:0, ease:Power0.easeNone},0.6)
        .from('#leave', 4, {y: 10, x: 120, scale: 0.9, rotation: 20, autoAlpha:0, ease:Power0.easeNone},0.6)
        .from('#lemon', 4, {y: 10, x: 120, autoAlpha:0,  ease:Expo.easeInOut},1)
        .from('#orgice', 4.5, {y: 50, x: 70, autoAlpha:0,  ease:Expo.easeInOut},1)
        .from('#lemon2', 4, {y: 10, x: 120, rotation:75, autoAlpha:0,ease:Power0.easeNone},0.6)
        .from('#section04 .info', 1, {y: 30, delay:5, autoAlpha:0, ease:Power0.easeNone},1.2)
        .to('#ice1', 46, {y: 100, rotation: 100, ease:Power0.easeNone},3)
        .to('#lemon2', 46, {y: 150, rotation: 120, ease:Power0.easeNone},3);
         */

      var section04_capt = new TimelineMax();
      section04_capt
        .to('.apples-parralax', 5, {autoAlpha:0, ease:Power4.easeOut}, '-=0.4')
        .from('#text-flexible', 0.3, {autoAlpha:1, ease:Power0.easeNone, onStart: DrawLineFlexibleSVG}, 0)
        .fromTo('#section04 .info', 0.3, {y: 30, autoAlpha:0, ease:Power0.easeNone}, {y: 0, autoAlpha:1, ease:Power0.easeNone}, 0)
        .fromTo('#section04 .info .stroke', 0.3, {y: 20, x: 0,  autoAlpha:0, ease:Power0.easeNone }, {y: 50, x: -45,  autoAlpha:1, ease:Power0.easeNone }, 0)
        .fromTo('#section04 .info p>span', 0.4, {autoAlpha: 0, ease:Power3.easeOut}, {autoAlpha: 1, ease:Power3.easeOut}, 0.1)
        .from('#section04 .heading.fright', 0.3, {autoAlpha:1, ease:Power4.easeOut, onStart: DrawLineGreatSVG}, 0.1);

        // .fromTo('#lemon2', 100, {y: 0, x: 0, rotation:75, autoAlpha:1,ease:Power0.easeNone}, {y: 0, x: 0, rotation:125, autoAlpha:1,ease:Power0.easeNone},'-=0.2')
        // .fromTo('#leave', 100, {y:0, x: 0, scale: 0.9, rotation: 0, autoAlpha:1, ease:Power0.easeNone}, {y:0, x: 0, scale: 0.9, rotation: 15, autoAlpha:1, ease:Power0.easeNone},'-=0.2')

        // pin the intro
        var section04Scene, section04_captScene;
        if($(window).width() <= 1024){
          section04Scene = new ScrollMagic.Scene({
            triggerElement: '#section04',
            triggerHook: 0.3,
            duration: 1500
          })
          .setTween(section04)
          .addTo(controller);

          section04_captScene = new ScrollMagic.Scene({
            triggerElement: '#section04',
            triggerHook: 0.5,
            duration: '90%'
          })
          .setTween(section04_capt)
          .addTo(controller);
        }else{
          section04Scene = new ScrollMagic.Scene({
            triggerElement: '#section04',
            triggerHook: 0.3,
            duration: 1800
          })
          .setTween(section04)
          .addTo(controller);

          section04_captScene = new ScrollMagic.Scene({
            triggerElement: '#section04',
            triggerHook: 0.25,
            duration: 500
          })
          .setTween(section04_capt)
          .addTo(controller)
          .on("enter", function (event) {
            $('#text-flexible').css('opacity', 1);
          })
          .on("leave", function (event) {
              $('#text-flexible').css('opacity', 0);
          });
        }

      function DrawLineGreatSVG(){
        painting('#text-great-01');
      }

      function DrawLineFlexibleSVG(){
        painting('#text-flexible');
      }

      //SECTION 5///////////////////////
      var section05 = new TimelineMax();
      section05
        .to('#section04', 0.5, {autoAlpha:0, ease:Power4.easeOut}, 0.5)
        .from('#section05 .video', 0.5, {y: 10, x: 50, autoAlpha:0, ease:Power4.easeOut, onComplete: playRetakeVideo2},0)
        .from('#section05 .stroke', 0.5, {y: -30, x: -30, autoAlpha:0, ease:Power0.easeNone},0.2)
        ;

        // pin the intro
      var section05Scene = new ScrollMagic.Scene({
          triggerElement: '#section05',
          triggerHook: 0.7,
          duration: 1000
        })
        .setTween(section05)
        .addTo(controller);

      function playRetakeVideo2(){
        retakeVideo2.play();
        retake2 = true;
      }

      // function playPitcherVideo(){
      //   pitcherVideo.volume = 0;
      //   pitcherVideo[0].play();
      //   pitcherVideo.animate({volume: 1}, 2000);
      //   pitcher = true;
      // }

      // parallax scene

      var parallaxTl = new TimelineMax();
      parallaxTl
        .from('.bcg', 2, {y: '-50%', ease:Power0.easeNone}, 0);

      var slideParallaxScene = new ScrollMagic.Scene({
          triggerElement: '.bcg-parallax',
          triggerHook: 1,
          duration: '100%'
        })
        .setTween(parallaxTl)
        .addTo(controller);

      function DrawTestimonialSVG(){
        painting('#testimonialpath');
      }

      var testiAuto = null;

      var testiSlide = function(e){
        var el = $('.testimony'),
            elWidth = $('.testimony')[0].getBoundingClientRect().width+10,
            tl;
        if($(window).width() > 768){
          tl = new TimelineMax();
          tl.to(el.eq(0), 1, {
            css: { marginLeft: -elWidth, opacity:0 },
            onComplete: function() {
              setTimeout(function(){
                el.eq(0).attr('style', '').appendTo('#testibox');
              },300);
            }}, 0)
            .fromTo(el.eq(3), 1, {xPercent:'100%', autoAlpha:0}, {xPercent:0, autoAlpha:1}, 0);
        }else{
          var elem = $('.testimony.active');
          if(elem.next().length){
            elem.removeClass('active').next().addClass('active');
          }else{
            elem.removeClass('active');
            el.eq(0).addClass('active');
          }
        }

      };

      var testiAutoSlide = function(){
        if (testiAuto) {
          clearInterval(testiAuto);
          testiAuto = null;
        }
        testiAuto = setInterval(function () {
          testiSlide();
        }, 5001);
      };

      var stopAutoPlay = function () {
        if (testiAuto) {
          clearInterval(testiAuto);
          testiAuto = null;
        }
      };

      var slideAuto = null;

      var slideSlide = function(e){
        var el = $('.item'),
            elWidth = $('.item')[0].getBoundingClientRect().width,
            tl = new TimelineMax();
        
        var elem = $('.item.active');
        if(e == 'prev'){
          if(elem.prev().length){
            elem.removeClass('active').prev().addClass('active');
          }else{
            elem.removeClass('active');
            el.last().addClass('active');
          }
        }else{
          if(elem.next().length){
            elem.removeClass('active').next().addClass('active');
          }else{
            elem.removeClass('active');
            el.eq(0).addClass('active');
          }
        }
      };

      var slideAutoSlide = function(){
        if (slideAuto) {
          clearInterval(slideAuto);
          slideAuto = null;
        }
        slideAuto = setInterval(function () {
          slideSlide();
        }, 5001);
      };

      var slidestopAutoPlay = function () {
        if (slideAuto) {
          clearInterval(slideAuto);
          slideAuto = null;
        }
      };

      $('.slide-prev').on('click',function(e){
        e.preventDefault();
        slideSlide('prev');
        slideAutoSlide();
      });

      $('.slide-next').on('click',function(e){
        e.preventDefault();
        slideSlide('next');
        slideAutoSlide();
      })

      

        // comments
      var testimony = new TimelineMax();
        testimony
          .from('#testimonialpath', 0.2, {autoAlpha:0, ease:Power0.easeNone, onStart: DrawTestimonialSVG}, 0)
          .staggerFromTo('.testimony', 0.5, {x: 100, autoAlpha:0, ease:Power4.easeOut},{x: 0, autoAlpha:1, ease:Power4.easeOut, onComplete:testiAutoSlide}, 0)
          .to('#section05', 0.5, {autoAlpha:0, ease:Power4.easeNone},1)
          .to('#testimonialpath', 0.5, {autoAlpha:0, ease:Power4.easeNone})
          .to('#testibox', 1, {autoAlpha:0, ease:Power0.easeNone});

        // pin the intro
        var testimonyScene;
        if($(window).innerWidth() <= 1280 && $(window).innerHeight() <= 768){
          testimonyScene = new ScrollMagic.Scene({
            triggerElement: '#testibox',
            triggerHook: 0.9,
            duration: 225
          })
          .setTween(testimony)
          .addTo(controller);
        }else{
          testimonyScene = new ScrollMagic.Scene({
            triggerElement: '#testibox',
            triggerHook: 0.9,
            duration: 1400
          })
          .setTween(testimony)
          .addTo(controller);
        }

        //SECTION 7///////////////////////
      var section07 = new TimelineMax();
      section07
        .from('#section07 h2', 1, {autoAlpha:1, ease:Power1.easeNone, onStart: drawHighSVG},0)
        .from('#section07 p', 0.7, {x:50, autoAlpha:0, ease:Power2.easeNone},"+=0.1")
        .from('#section07 a', 0.5, {x:40, autoAlpha:0, ease:Power2.easeNone},"+=0.1");

        // pin the intro
      var section07Scene = new ScrollMagic.Scene({
          triggerElement: '#section07',
          triggerHook: 0.9,
          duration: '80%'
        })
        .setTween(section07)
        .addTo(controller);

      function drawHighSVG(){
        painting('#high_profit_margin');
      }

      function playPassionVideo(){
        passionVideo.play();
        passion = true;
      }

      function DrawLineConclusion(){
        painting('#text-Conclusion-06');
      }

      function DrawLineMixologi(){
        painting('#text-_mixtura_and_mixology');
      }

      function DrawLineBeyonMixology(){
        painting('#text-_mixtura_beyond_mixology');
        setTimeout(function(){
          $('#mixology').addClass('bgIn');
          $('.sushi img').addClass('in');
        }, 1500);
        if ($(window).innerHeight()>=1000){
          setTimeout(function(){
            playPassionVideo();
          }, 2001);
        }
        else{
          setTimeout(function(){
            playPassionVideo();
          }, 5001);
        }
      }

      function DrawTooltip05(){
        painting('#arrow-tooltip5');
      }
      function DrawTooltip04(){
        painting('#arrow-tooltip4');
      }
      function DrawTooltip01(){
        painting('#arrow-tooltip1');
      }
      function DrawTooltip02(){
        painting('#arrow-tooltip2');
      }
      function DrawTooltipSauce(){
        painting('#arrow-tooltip3');
      }

      var cakeSection = new TimelineMax();
      cakeSection
        .from('#first h2', 1, {y:20, autoAlpha:0, ease:Power0.easeNone, onStart: DrawLineConclusion},0)
        .from('#first .info', 1, {y:50,autoAlpha:0, ease:Power0.easeNone}, 0.5)
        .from('.cake img', 3, {y: -150, autoAlpha:0, ease:Power0.easeNone}, 0.5)
        .from('.cake #tooltip1', 0.5, { autoAlpha:0, ease:Power2.easeIn}, 3)
        .from('#arrow-tooltip1', 0.3, { autoAlpha:0, ease:Power2.easeIn, onStart: DrawTooltip01}, 3)
        .from('.cake #tooltip2', 0.5, { autoAlpha:0, ease:Power2.easeIn},3)
        .from('#arrow-tooltip2', 0.3, { autoAlpha:0, ease:Power2.easeIn, onStart: DrawTooltip02}, 3)


      var cakeScene = new ScrollMagic.Scene({
          triggerElement: '#section08',
          triggerHook: 1,
          duration: 500
        })
        .setTween(cakeSection)
        .addTo(controller);

        //SECTION 8///////////////////////
        var section08 = new TimelineMax();
        section08
          .from('#section08 .video', 1, {autoAlpha:0, ease:Power0.easeNone, onComplete: DrawLineBeyonMixology}, 0)
          //.from('#sauce', 1, {autoAlpha:0, ease:Power0.easeNone, onComplete: DrawTooltipSauce}, 0)
          .from('#sauce img', 1, {autoAlpha:0, rotation: 45, ease:Power2.easeOut}, 0.5)
          .from('#sauce #tooltip3', 0.3, {autoAlpha:0, ease:Power2.easeOut, onComplete: DrawTooltipSauce}, 1)
          .from('#sauce #arrow-tooltip3', 0.3, { autoAlpha:0, ease:Power2.easeOut, }, 1)
          
          
          // .from('#tooltip5', 0.3, { autoAlpha:0, ease:Power0.easeNone}, '+=10')
          // .from('#arrow-tooltip5', 0.3, { autoAlpha:0, ease:Power2.easeNone, onComplete: DrawTooltip05}, '+=0')
          // .from('#tooltip4', 0.3, { autoAlpha:0, ease:Power0.easeNone}, '-=0.2')
          // .from('#arrow-tooltip4', 0.3, { autoAlpha:0, ease:Power2.easeNone, onComplete: DrawTooltip04}, '+=0')
          // .from('.not-just-drink', 15, {y:70, autoAlpha:0, ease:Power2.easeNone}, '+=0.5')
          ;

        var heightSection8 = $('#section08').height();

        // pin the intro
        if($(window).width() <= 1500){
          var section08Scene = new ScrollMagic.Scene({
            triggerElement: '.bartender',
            triggerHook: 0.2,
            duration: '75%'
          })
          .setTween(section08)
          .addTo(controller);
        }
        else{
          var section08Scene = new ScrollMagic.Scene({
            triggerElement: '.bartender',
            triggerHook: 0.5,
            duration: '75%'
          })
          .setTween(section08)
          .addTo(controller);
        }
        

        var section08b = new TimelineMax();
        section08b
          .from('.bartender', 1, {x:-50,autoAlpha:0, ease:Power4.easeOut, onStart: DrawLineMixologi}, 0)
          .from('.infomixology', 1, {y:30, autoAlpha:0, ease:Power0.easeOut}, 0);

        var section08bScene = new ScrollMagic.Scene({
          triggerElement: '.bartender',
          triggerHook: 1,
          duration: 500
        })
        .setTween(section08b)
        .addTo(controller);

        var section08c = new TimelineMax();
        section08c
          .from('.not-just-drink', 0.1, {autoAlpha:0, ease:Power2.easeNone}, 1)
          .from('#tooltip5', 0.1, { autoAlpha:0, ease:Power2.easeNone}, 0)
          .from('#arrow-tooltip5', 0.1, { autoAlpha:0, ease:Power2.easeNone, onStart: DrawTooltip05}, 0.5)
          .from('#tooltip4', 0.1, { autoAlpha:0, ease:Power2.easeNone},1.2)
          .from('#arrow-tooltip4', 0.1, { autoAlpha:0, ease:Power2.easeNone, onStart: DrawTooltip04}, 1.3);
        
        if($(window).width() <= 1500){
          var section08cScene = new ScrollMagic.Scene({
            triggerElement: '#mixology',
            triggerHook: 0.7,
            duration: '100%'
          })
          .setTween(section08c)
          .addTo(controller);
        }
        else{
          var section08cScene = new ScrollMagic.Scene({
            triggerElement: '#trd',
            triggerHook: 0.5,
            duration: '75%'
          })
          .setTween(section08c)
          .addTo(controller);
        }
        

      var formContact = new TimelineMax();
      formContact.from('#txtinquery', 1, {autoAlpha:0, ease:Power0.easeNone, onStart: drawInquerySVG},1);

      var formContactScene = new ScrollMagic.Scene({
          triggerElement: '.formcontact',
          triggerHook: 0.8,
          duration: '0px'
        })
        .setTween(formContact)
        .addTo(controller);


      function drawInquerySVG(){
        painting('#txtinquery');
      }

      // loop through each .section element
      // $('.section').each(function(){

      //   // build a scene
      //   var ourScene = new ScrollMagic.Scene({
      //     triggerElement: this.children[0],
      //     triggerHook: 0.8
      //   })
      //   .setClassToggle(this, 'fade-in') // add class to section01
      //   .addIndicators({
      //     name: 'fade scene',
      //     colorTrigger: 'black',
      //     colorStart: '#75C695',
      //     colorEnd: 'pink'
      //   }) // this requires a plugin
      //   .addTo(controller)
      //   .removeIndicators();

      // });



        // CUSTOM SELECT/////////
      $('select').each(function(){
        var $this = $(this), numberOfOptions = $(this).children('option').length;

        $this.addClass('select-hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());

        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        var $listItems = $list.children('li');

        $styledSelect.click(function(e) {
         if($('.select-options').is(':visible')) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');

            $this.val($(this).attr('rel'));

            $list.hide();
            //console.log($this.val());

         } else {
            e.stopPropagation();
            $('div.select-styled.active').each(function(){
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
         }//end if
        });

        $listItems.click(function(e) {
          e.stopPropagation();
          $styledSelect.text($(this).text()).removeClass('active');
          $this.val($(this).attr('rel'));
          $list.hide();

          if($(this).attr('rel') === "Demo Request"){
            request('demo');
          }else if($(this).attr('rel') === "Sales Kit Request"){
            request('sales');
          }else if($(this).attr('rel') === "Mixtura Sample Request"){
            request('sample');
          }
            //console.log($this.val());
        });

        $(document).click(function() {
          $styledSelect.removeClass('active');
          $list.hide();
        });
      }); //CUSTOM SELECT

      $(document).on('click','.toggle-dialog',function(e){
        e.preventDefault();
        var target = $(this).attr('href');
        $(target).fadeIn(100);
        $('.dialog-slider').height($('.dialog-slider .item img').height());
        $('body').addClass('dialog-open');
        slideAutoSlide();
      });

      $(document).on('click', '.js-close-dialog',function(e){
        e.preventDefault();
        $('.dialog').fadeOut(100);
        $('body').removeClass('dialog-open');
        slidestopAutoPlay();
      });

      function request(type){
        if(type === 'demo'){
          $("textarea[name=message]").val("I would like to request a Mixtura demo.");
          $("select[name=select]").val("Demo Request");
          $(".select-styled").text('Demo Request');
        }else if(type === 'sales'){
          $("textarea[name=message]").val("I would like to request more information about Mixtura.");
          $("select[name=select]").val("Sales Kit Request");
          $(".select-styled").text("Sales Kit Request");
        }else if(type === 'sample'){
          $("textarea[name=message]").val("I would like to request samples of Mixtura.");
          $("select[name=select]").val("Mixtura Sample Request");
          $(".select-styled").text("Mixtura Sample Request");
        }
      }

      $(document).on('click','a[data-request]', function(e){
        e.preventDefault();
        var el = $(this).data('request');
        request(el);
      })

      $(window).scroll(function(){
          var scrollTop = $(window).scrollTop(),
              section3OffsetTop = $('#section03').offset().top + 1000,
              section2OffsetTop = $(window).width() <= 1600 ? $('#section02').offset().top + 300 : $('#section02').offset().top + 50,
              section5OffsetTop = $('#section05').offset().top + 500,
              section8OffsetTop = $(window).width() <= 1024 ? $('#passionVideo').offset().top + 100 : $('#passionVideo').offset().top + 500;

          if(scrollTop > section3OffsetTop || scrollTop <= $('#section03').offset().top - 500){
            if(!igaVideo.paused()){
              igaVideo.pause();
            }
          }else if(scrollTop < section3OffsetTop && scrollTop > $('#section03').offset().top){
            if(igaVideo.paused() && iga){
              igaVideo.volume(1);
              igaVideo.play();
            }
          }
          if(scrollTop > section2OffsetTop || scrollTop <= $('#section02').offset().top - 500){
            if(!retakeVideo.paused()){
              retakeVideo.pause();
            }
          }else if(scrollTop < section2OffsetTop && scrollTop >= $('#section02').offset().top){
            if(retakeVideo.paused() && retake){
              retakeVideo.volume(1);
              retakeVideo.play();
            }
          }

          if(scrollTop > section5OffsetTop || scrollTop <= $('#section05').offset().top - 500){
            if(!retakeVideo2.paused()){
              retakeVideo2.pause();
            }
          }else if(scrollTop < section5OffsetTop && scrollTop >= $('#section05').offset().top){
            if(retakeVideo2.paused() && retake2){
              retakeVideo2.volume(1);
              retakeVideo2.play();
            }
          }

          if(scrollTop > section8OffsetTop || scrollTop <= $('#passionVideo').offset().top - 1000){
            if(!passionVideo.paused()){
                passionVideo.pause();
                passionVideo.setCurrentTime(21);
              passionPlay = false;
            }
          }else if(scrollTop < section8OffsetTop && scrollTop >= $('#passionVideo').offset().top){
            if(passionVideo.paused() && passion){
              passionVideo.volume(1);
              passionVideo.play();
            }
          }
          if($(window).width() <= 1024){
            if(scrollTop > section8OffsetTop){
              TweenLite.to('#video3',0.5, {autoAlpha:0}, 0);
            }else if(scrollTop < section8OffsetTop && scrollTop >= $('#passionVideo').offset().top){
              TweenLite.to('#video3',0.5, {autoAlpha:1}, 0);
            }
          }
      });

      if($(window).innerWidth() <= 768){
        TweenLite.set(".off-mob", {clearProps:"all", x:0, y:0, scale:0, rotation:0});
      }
    });
  })();


